<template>
  <span v-if="fromFlujoReserva" class="text-primary text-start title title-size mb-2">
    {{ $t('home.form.personalInformation.welcomeBack') }}
  </span>
  <template v-if="showRegisterValue">
    <form autocomplete="on" @submit.prevent="registrarLoguearUsuario(usuarioRegistro)">
      <div class="text-primary mb-3 introduce-msg">
        <span>{{ $t('home.form.personalInformation.dataRegister') }}</span>
      </div>
      <div class="mb-3">
        <input
          id="exampleFormControlInput1"
          v-model="usuarioRegistro.email"
          type="email"
          class="text-primary form-control text-start p text-12"
          :placeholder="'*' + $t('home.form.personalInformation.email')"
          required
          :disabled="usuarioFicticio" />
      </div>
      <div class="position-relative" :class="{ 'mb-3': !isPasswordStrong, 'mb-2': isPasswordStrong }">
        <input
          v-model="usuarioRegistro.password"
          :type="passwordVisible ? 'text' : 'password'"
          class="text-primary form-control text-start pr-5 text-12"
          autocomplete="off"
          :placeholder="'*' + $t('home.form.personalInformation.passwordRegister')"
          required
          @click.right.prevent
          @focus="isPasswordFocused = true"
          @blur="isPasswordFocused = false"
          @keydown="keydown"
          @copy.prevent
          @paste.prevent />
        <span
          class="pointer position-absolute toggle-password text-decoration-underline text-landing-detail unselectable text-12"
          @click="togglePasswordVisibility">
          {{
            passwordVisible ? $t('home.form.personalInformation.ocultar') : $t('home.form.personalInformation.mostrar')
          }}
        </span>
      </div>
      <transition name="fade">
        <div
          v-show="!isPasswordStrong && (isPasswordFocused || usuarioRegistro.password?.length > 0)"
          class="password-validation mb-3">
          <p
            class="mb-0 sub q-flex items-center"
            :class="{ 'green-text': pwRequirements.minLength, 'red-text': !pwRequirements.minLength }">
            <i class="fa-solid fa-xs me-2" :class="pwRequirements.minLength ? 'fa-check' : 'fa-x'" />
            {{ $t('home.form.personalInformation.password8CharReq') }}
          </p>
          <p
            class="mb-0"
            :class="{ 'green-text': pwRequirements.hasUpperCase, 'red-text': !pwRequirements.hasUpperCase }">
            <i class="fa-solid fa-xs me-2" :class="pwRequirements.hasUpperCase ? 'fa-check' : 'fa-x'" />
            {{ $t('home.form.personalInformation.password1MayusReq') }}
          </p>
          <p class="mb-0" :class="{ 'green-text': pwRequirements.hasNumber, 'red-text': !pwRequirements.hasNumber }">
            <i class="fa-solid fa-xs me-2" :class="pwRequirements.hasNumber ? 'fa-check' : 'fa-x'" />
            {{ $t('home.form.personalInformation.password1NumReq') }}
          </p>
        </div>
      </transition>
      <transition name="fade">
        <div v-show="isPasswordStrong" class="password-validation">
          <p class="sub green-text q-flex items-center">
            <i class="fa-solid fa-xs me-2 fa-check" />
            {{ $t('home.form.personalInformation.passwordSeguridadBuena') }}
          </p>
        </div>
      </transition>

      <div class="mb-3">
        <input
          id="exampleFormControlInput1"
          v-model="usuarioRegistro.nombre"
          type="text"
          class="text-primary form-control text-start text-12"
          :placeholder="'*' + $t('home.form.personalInformation.name')"
          required />
      </div>
      <div class="mb-3">
        <input
          id="exampleFormControlInput1"
          v-model="usuarioRegistro.apellidos"
          type="text"
          class="text-primary form-control text-start text-12"
          :placeholder="'*' + $t('home.form.personalInformation.lastName')"
          required />
      </div>
      <div class="mb-3">
        <Datepicker
          v-model="usuarioRegistro.fechaNacimiento"
          :locale="locale"
          auto-apply
          required
          :placeholder="'*' + $t('home.form.personalInformation.birthDate')"
          :format="format"
          :flow="flowCalendar" />
      </div>
      <div class="mb-3">
        <InputTelefono
          v-model="usuarioRegistro.telefono"
          :placeholder="'*' + $t('home.form.personalInformation.phone')"
          required />
      </div>

      <template v-if="isUsuariosHomologados">
        <p class="introduce-msg semibold mb-3">
          {{ $t('home.form.personalInformation.datosFacturacion') }}
        </p>
        <FormularioDatosFiscales
          ref="formularioDatosFiscalesRef"
          :tipo="TIPO_DATOS_FISCALES.EMPRESA"
          ocultar-contacto
          :pais-code-default="agenciaStore.paisCode"
          class="mb-3" />
        <p class="introduce-msg semibold mb-3">
          {{ $t('home.form.personalInformation.comentario') }}
        </p>
        <div class="mb-3">
          <textarea
            v-model="usuarioRegistro.observaciones"
            class="text-primary form-control text-start text-12 registro-comentario"
            :placeholder="$t('home.form.personalInformation.comentarioPlaceholder')"
            rows="3" />
        </div>
      </template>

      <div class="w-100 m-auto">
        <div class="col-12">
          <div class="form-check border-0 d-flex align-items-center">
            <input
              id="aceptarMailing"
              v-model="usuarioRegistro.mailingPublicidadActivo"
              class="form-check-input"
              type="checkbox" />
            <label class="form-check-label text-start ms-2 mt-1" for="aceptarMailing">
              <span class="text-12">{{ $t('home.form.personalInformation.noRecibirMailing') }}</span>
            </label>
          </div>
          <div class="form-check border-0 d-flex align-items-center">
            <input id="flexCheckChecked" class="form-check-input" type="checkbox" value="" required />
            <label class="form-check-label text-start ms-2 mt-1" for="flexCheckChecked">
              <span class="text-12">{{ $t('home.form.policy.readAcceptsLos') }}</span>
              <a class="btn btn-link p-0 ms-1" @click="openInTab('TerminosCondiciones')">
                <span class="text-12">{{ $t('home.form.policy.terminosCondiciones') }}</span>
              </a>
              <span class="text-12">{{ $t('home.form.policy.andLa') }}</span>
              <a class="btn btn-link p-0" @click="openInTab('PoliticaPrivacidad')">
                <span class="text-12">{{ $t('home.form.policy.politicaPrivacidad') }}.</span>
              </a>
            </label>
          </div>
        </div>
      </div>

      <MyGocuButton
        type="submit"
        class="my-3 mx-auto w-100"
        :label="
          isUsuariosHomologados
            ? $t('home.form.personalInformation.enviarSolicitud')
            : $t('home.form.personalInformation.registrar')
        " />

      <span class="cambio-vista text-12" @click="emits('mostrarLogin')">
        {{ $t('home.form.personalInformation.yaTienesCuenta') }}
        <span class="text-decoration-underline">{{ $t('header.user.login') }}</span>
      </span>
    </form>
  </template>
  <template v-else>
    <form autocomplete="off" @submit.prevent="loginUser(informacionLogin.email, informacionLogin.password)">
      <div :class="['text-primary', 'mb-2', 'introduce-msg', { 'mt-3': fromFlujoReserva }]">
        <span>{{ $t('home.form.personalInformation.contraseniaLogin') }}</span>
      </div>
      <div class="mb-3">
        <input
          v-model="informacionLogin.email"
          type="text"
          class="form-control text-start text-12"
          autocomplete="off"
          :placeholder="$t('home.form.personalInformation.email')"
          required />
      </div>
      <div class="mb-3 position-relative">
        <input
          v-model="informacionLogin.password"
          :type="passwordVisible ? 'text' : 'password'"
          class="text-primary form-control text-start pr-5 text-12"
          autocomplete="off"
          :placeholder="$t('home.form.personalInformation.password')"
          required
          @click.right.prevent
          @copy.prevent
          @paste.prevent />
        <span
          class="pointer position-absolute toggle-password text-decoration-underline text-landing-detail unselectable text-12 mostrar"
          @click="togglePasswordVisibility">
          {{
            passwordVisible ? $t('home.form.personalInformation.ocultar') : $t('home.form.personalInformation.mostrar')
          }}
        </span>
      </div>

      <MyGocuButton type="submit" class="m-auto w-100 mb-3" :label="$t('login.entrar')" />
      <span class="cambio-vista text-center text-decoration-underline m-0 text-12" @click="mostrarRecuperarPassword">
        ¿{{ $t('login.forgetPassword') }}?
      </span>
    </form>
  </template>
</template>

<script setup>
  import { alertAutoCloseWarningWithoutCallback, alertSuccess } from '@/services/utils/AlertUtils';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import { reactive, ref, watch, computed, onBeforeMount } from 'vue';
  import { createToaster } from '@meforma/vue-toaster';
  import Datepicker from '@vuepic/vue-datepicker';
  import UsuarioApiService from '@/services/api/UsuarioApiService';
  import { controlErrorRegistrarLoginUsuario } from '@/services/utils/ErrorControl';
  import router from '@/router';
  import { useI18n } from 'vue-i18n';
  import { validateEmailFormat } from '@/helpers/stringUtiles';
  import { useUserStore } from '@/store_pinia/userStore';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import LoginApiService from '@/services/api/LoginApiService';
  import InputTelefono from '@/components/inputs/InputTelefono.vue';
  import MyGocuButton from '@/components/common/buttons/MyGocuButton.vue';
  import FormularioDatosFiscales from '@/modules/viajesGrupos/components/FormularioDatosFiscales.vue';
  import { TIPO_DATOS_FISCALES } from '@/constants/datosFiscalesConstants';
  import { normalizeDateYYYYMMDD } from '@/helpers/dateUtiles';
  import moment from 'moment-timezone';

  const emits = defineEmits(['mostrarLogin', 'mostrarRecuperarPassword', 'usuarioLogueado']);

  const props = defineProps({
    email: {
      type: String,
      required: true,
      default: '',
    },
    showRegister: {
      type: Boolean,
      required: false,
      default: true,
    },
    fromFlujoReserva: {
      type: Boolean,
      required: false,
      default: false,
    },
    usuarioFicticio: {
      type: Object,
      required: false,
      default: null,
    },
  });

  const { t, locale } = useI18n();
  const showRegisterValue = ref(props.showRegister);
  const isPasswordFocused = ref(false);
  const agenciaStore = agenciaStoreModule();
  const isUsuariosHomologados = computed(() => agenciaStore.usuariosHomologados);
  const formularioDatosFiscalesRef = ref(null);

  const passwordVisible = ref(false);

  function togglePasswordVisibility() {
    passwordVisible.value = !passwordVisible.value;
  }

  const informacionLogin = reactive({
    email: props.email,
    password: null,
  });

  const usuarioRegistro = reactive({
    nombre: null,
    apellidos: null,
    telefono: null,
    email: props.email,
    password: null,
    fechaNacimiento: null,
    mailingPublicidadActivo: null,
    observaciones: null,
  });

  const pwRequirements = reactive({
    minLength: false,
    hasUpperCase: false,
    hasNumber: false,
  });

  const isPasswordStrong = computed(() => {
    return pwRequirements.minLength && pwRequirements.hasUpperCase && pwRequirements.hasNumber;
  });

  watch(
    () => usuarioRegistro.password,
    newPassword => {
      pwRequirements.minLength = newPassword.length >= 8;
      pwRequirements.hasUpperCase = /[A-Z]/.test(newPassword);
      pwRequirements.hasNumber = /[0-9]/.test(newPassword);
    }
  );

  const toaster = createToaster({ position: 'top-right' });
  const flowCalendar = ref(['year', 'month', 'calendar']);
  const format = date => normalizeDateYYYYMMDD(date);
  const storeHabitacion = informacionHabitacion();
  const userStore = useUserStore();
  const loadingStore = useLoadingStore();

  const passwordErrorVisible = ref(false);

  const openInTab = routeName => {
    window.open(router.resolve({ name: routeName }).href, '_blank');
  };

  function loadUsuarioFicticioData() {
    if (!props.usuarioFicticio || !props.showRegister) return;

    if (props.usuarioFicticio.nombre) usuarioRegistro.nombre = props.usuarioFicticio.nombre;
    if (props.usuarioFicticio.apellidos) usuarioRegistro.apellidos = props.usuarioFicticio.apellidos;
    if (props.usuarioFicticio.fechaNacimiento) {
      const normalized = normalizeDateYYYYMMDD(props.usuarioFicticio.fechaNacimiento);
      if (normalized) {
        usuarioRegistro.fechaNacimiento = moment(normalized, 'YYYY-MM-DD');
      }
    }
  }

  async function loginUser(username, password) {
    try {
      loadingStore.show();
      const res = await LoginApiService.login(username, password);
      if (res.token == null) {
        alertAutoCloseWarningWithoutCallback(3000, t('errors.inesperado'));
      } else {
        const usuario = userStore.login(res.token);
        actualizarInformacionReservaConUsuarioLogeado(storeHabitacion.getReservas, usuario);
        toaster.success(t('header.login.msg.loginSuccess'));
        emits('usuarioLogueado');
      }
    } catch (error) {
      console.error(error);
      const errorStatus = error?.response?.status;
      if (errorStatus === 401) {
        toaster.error('Los datos de usuario son invalidos');
      }
    } finally {
      loadingStore.hide();
    }
  }

  // function mostrarRegistrarUsuario() {
  // 	emits('mostrarRegistrarUsuario');
  // }

  function mostrarRecuperarPassword() {
    emits('mostrarRecuperarPassword', informacionLogin.email);
  }

  /**
   * Valida si existen reservas en el store y si la primera reserva es propia
   * , que es del usuario que se acaba de logear,actualiza la informacion del
   * usuario de la reserva con el usuario logeado
   * @param {Array} listaReservas - La lista de reservas a actualizar.
   * @param {Object} informacionUsuario - La información del usuario logeado.
   */
  function actualizarInformacionReservaConUsuarioLogeado(listaReservas, informacionUsuario) {
    if (listaReservas.length > 0 && listaReservas[0].reservaPropia) {
      listaReservas[0].usuario = {
        nombre: informacionUsuario.nombre,
        apellido: informacionUsuario.apellidos.split(' ')[0],
        fechaNacimiento: informacionUsuario.fechaNacimiento,
      };
    }
  }

  async function registrarLoguearUsuario(informacionUsuario) {
    try {
      loadingStore.show();
      if (!isPasswordStrong.value) {
        toaster.error(t('home.form.personalInformation.errorRegPassword'));
        return;
      }

      if (!validateEmailFormat(informacionUsuario.email)) {
        toaster.error(t('home.form.personalInformation.errorEmailFormal'));
        return;
      }

      if (usuarioRegistro.fechaNacimiento === null) {
        toaster.error('Ingrese la fecha de nacimiento');
        return;
      }

      let valorRegistrar = {
        nombre: informacionUsuario.nombre,
        apellidos: informacionUsuario.apellidos,
        telefono: informacionUsuario.telefono,
        email: informacionUsuario.email,
        password: informacionUsuario.password,
        fechaNacimiento: format(informacionUsuario.fechaNacimiento),
        mailingPublicidadActivo: !informacionUsuario.mailingPublicidadActivo,
      };

      if (valorRegistrar.telefono) {
        valorRegistrar.telefono = valorRegistrar.telefono.replace(/\s+/g, '');
      }

      if (isUsuariosHomologados.value) {
        if (!formularioDatosFiscalesRef.value?.validateAndShowErrors()) {
          return;
        }

        const datosFiscales = { ...formularioDatosFiscalesRef.value.formularioData };
        datosFiscales.telefono = valorRegistrar.telefono;
        datosFiscales.email = informacionUsuario.email;

        valorRegistrar.datosFiscales = datosFiscales;
        valorRegistrar.observaciones = informacionUsuario.observaciones;

        await UsuarioApiService.doRegistro(valorRegistrar);
        emits('usuarioLogueado');
        alertSuccess(t('home.form.personalInformation.solicitudEnviada'));
        return;
      }

      let res;
      if (props.usuarioFicticio) {
        res = await UsuarioApiService.doRegistroAndLoginFicticio(props.usuarioFicticio.uuid, valorRegistrar);
      } else {
        res = await UsuarioApiService.registrarYLoguear(valorRegistrar);
      }

      if (res.token == null) {
        alertAutoCloseWarningWithoutCallback(3000, t('errors.inesperado'));
      } else {
        userStore.login(res.token);
        emits('usuarioLogueado');
        toaster.success(t('home.form.personalInformation.registradoCorrect'));
      }
    } catch (error) {
      console.error(error);
      controlErrorRegistrarLoginUsuario(error);
    } finally {
      loadingStore.hide();
    }
  }

  watch(isPasswordStrong, newValue => {
    passwordErrorVisible.value = !newValue;
  });

  onBeforeMount(() => {
    loadUsuarioFicticioData();
  });
</script>

<style lang="scss" scoped>
  .cambio-vista {
    color: var(--landing-text-color, var(--bs-primary)) !important;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    transition: 0.3s ease-in-out;

    &:hover {
      color: var(--landing-detail-color, var(--bs-secondary)) !important;
    }
  }

  .position-relative .toggle-password {
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    z-index: 2;
  }

  .password-validation p {
    font-size: 11px;
  }

  .red-text {
    color: var(--rojo-500);
  }

  .green-text {
    color: var(--verde-500);
  }

  .unselectable {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  :deep(.dp__input) {
    text-align: start !important;
    @media only screen and (max-width: 768px) {
      font-size: 12px !important;
    }
  }

  .introduce-msg {
    font-size: 14px;
    color: var(--landing-text-color, var(--bs-primary)) !important;
  }

  .text-landing-detail {
    color: var(--landing-detail-color, var(--bs-primary)) !important;
  }

  .text-12 {
    @media only screen and (max-width: 768px) {
      font-size: 12px !important;
    }
  }

  .mostrar {
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }

  .text-mobile {
    @media only screen and (max-width: 768px) {
      font-size: 14px !important;
      font-weight: 600 !important;
    }
  }

  .btn-link {
    margin-bottom: 1px;
  }

  .registro-comentario {
    min-height: 80px;
    resize: vertical;
  }
</style>
